module.exports = __webpack_public_path__ + "img/xiaohongshu.b091de41.jpg";